// extracted by mini-css-extract-plugin
export default {"input":"create-series-modal_input__xob36"};